import { useEffect, useRef } from "react";

// G27: poll only while the tab is visible, refresh immediately when it comes
// back, and back off (up to 5 minutes) while requests keep failing.
export default function usePolling(fn, intervalMs, deps = []) {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => {
    let alive = true;
    let timer = null;
    let failures = 0;
    const schedule = () => {
      const delay = Math.min(intervalMs * 2 ** failures, 5 * 60 * 1000);
      timer = setTimeout(tick, delay);
    };
    const tick = async () => {
      if (!alive) return;
      if (document.hidden) { schedule(); return; }
      try { await fnRef.current(); failures = 0; } catch (e) { failures = Math.min(failures + 1, 5); }
      if (alive) schedule();
    };
    const onVisible = () => {
      if (document.hidden || !alive) return;
      clearTimeout(timer);
      tick();
    };
    tick();
    document.addEventListener("visibilitychange", onVisible);
    return () => { alive = false; clearTimeout(timer); document.removeEventListener("visibilitychange", onVisible); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intervalMs, ...deps]);
}
